import { IApiPagination, IPagination } from "../../../interfaces/IPagination";
import {
  ProductInterface,
  TProductFilter,
} from "../../../interfaces/productInterface";
import { useProductsFilterQuery } from "../queries/useProductsQuery";

type Response = {
  data?: ProductInterface[];
  isLoading: boolean;
  paginationData?: IPagination;
};

export type UseProductParams = {
  filter: TProductFilter;
  pagination?: IApiPagination;
};

export const useProductsFilter = (opt: UseProductParams): Response => {
  const pagination = opt.pagination || { page: 1, pageSize: 20 };
  const { data, isLoading } = useProductsFilterQuery({ ...opt, pagination });
  return {
    data: data?.data?.products || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
